import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Navigations from './Nav';
import Demo from './Demo';
import Second from './Second';
import SecondDemo from './SecondDemo';
import ScrollDelay from './ScrollDelay';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ScrollDelay delayTime={500000}>
    <App />
    </ScrollDelay>
    {/* <Demo/> */}
    {/* <Second/> */}
    {/* <SecondDemo /> */}
    {/* <Navigations/> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
